import React from 'react';
import './transaction.css';
import { useEffect } from 'react';
import { numberWithCommas }  from '../../../../../utils/numberFormatter';


const Transaction = (props) => {
    let success=!("code" in props.transInfo);
    
    
    

    const setRecieptInfoLStorage = (recieptInfo) => {
        localStorage.setItem("recieptInfo", JSON.stringify(recieptInfo));
    }
    if(success){
        useEffect(()=>{
            setRecieptInfoLStorage(props.transInfo);
        },[props.transInfo]);
    }
    
    return (<div className="modalBackground">
                <div className="modalContainer">
                    <div className="title">
                        <img className="auto-style1" src="/media/icons/PCS-Logo-RGB-2COL-BLUE-GOLD.png" alt="PCS Brand - Navigate to Welcome Screen"/>
                        <hr/> 
                        {success ? <img alt="success" src="/media/icons/success-green-check-mark.svg" />:<img alt="failed" src="/media/icons/failed-red-x-line.svg" />}
                    </div>

                    {success ? <div className="body">
                            <h3 className='body-title'>Your {'$'+numberWithCommas(+props.transInfo.totalAmount)} payment has been submitted</h3>
                            <p className='body-text'>A payment of <strong>{'$'+numberWithCommas(+props.transInfo.totalAmount)}</strong> from
                                {(props.transInfo.selectedPayMethod[0] === 'card')
                                    ? ' card ' : (props.transInfo.selectedPayMethod[1] === 'checking')
                                    ? ' checking account ' : ' savings account '} ending in <strong>{props.transInfo.account_number}</strong> was submitted at {props.transInfo.time} on {props.transInfo.date}. Your payment confirmation number is <strong>{props.transInfo.transactionID}</strong>.</p>
                            <p className='body-text'>Please allow 1-3 business days for processing. Payment on accounts with lapsed or cancelled policies does not guarantee reinstatement.</p>
                            <p className='body-text'>An email confirmation has been sent.</p>
                            <p className='body-link' style={{color:"#0057B8"}}><a href="/receipt" rel="noopener noreferrer" target="_blank">View or save receipt</a></p>
                            <div className='modalFooter'>
                                {!props.pcgx && <button onClick={props.onClickHandler} className = "closeButton">DONE</button>}
                                <p  className="thanks-line">Thank you for entrusting us with your personal insurance protection.</p>
                            </div>
                        </div>:
                    <div className="body">
                        {props.transInfo.code!=="Something's amiss" ? <h3 className='body-title'>Your payment has been declined</h3>:<h3 className='body-title'>{props.transInfo.code}</h3>}
                        <p className='body-text'>{props.transInfo.message}</p>
                        <div className='modalFooter'>
                            {!props.pcgx && <button onClick={props.onClickHandler} className = "closeButton">DONE</button>}
                            <p  className="thanks-line">Thank you for entrusting us with your personal insurance protection.</p>
                        </div>
                    </div>}

                
                </div>
            </div>)
        

}

export default Transaction;


// WEBPACK FOOTER //
// ./src/components/atomic/pages/AccountsPage/transaction/Transaction.js